if (!customElements.get("comparison-table")) {
  customElements.define(
    "comparison-table",
    class ComparisonTable extends HTMLElement {
      constructor() {
        super();
        //console.log("load section")
        const colElements = this.querySelectorAll('[data-product-col]');
        console.log(colElements);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const productId = urlParams.get('compare');
        let featureIndex = 0;

        for (var i=0; i<colElements.length; i++) { // check each column for id match
          let colId = colElements[i].dataset.productId;
          //console.log(productId + " vs " + colId);
          if(colId == productId){
            //console.log("match");
            featureIndex = i + 1;
          }
        }
        this.classList.add("feature-col-"+featureIndex);
        


        /* Mobile Table Switching */
        const node = this.querySelector('[data-compare-table]') // grab testimonial wrapper
        const nextButtons = this.querySelectorAll('[data-compare-next]');
        let slideCount = parseInt(this.dataset.columnCount), //count slides
            currentSlide = 1;
      //console.log(slideCount)

        /* Hook up the individual HTML elements to the functions */
        for (var i=0; i<nextButtons.length; i++) { // attach and event handler for each link
          nextButtons[i].addEventListener('click', nextSlide);
        }

        function nextSlide(e){


          //moveToSlide(currentSlide+1); // add one to index, move to the next
          let n = currentSlide + 1;
        
          currentSlide = (n + slideCount) % slideCount;
        
          node.className = 'active-row-'+n;
  
      }
      }
    }
  );
}
